module.exports = __webpack_public_path__ + "images/signin-question.png";